/*jshint esversion: 6 */
import "../../../../template-parts/blocks/faq/faq.js";
import "../../../../template-parts/blocks/artists/artists.js";
import "../../../../template-parts/blocks/mentions/mentions.js";
